import { Theme } from "@material-ui/core/styles";
import createStyles from "@material-ui/core/styles/createStyles";
import commonStyle from "../CommonStyle";

const outgoingWebhookConfigurationModalStyle = (theme: Theme) =>
    createStyles({
        ...commonStyle(theme),

        root: {
            paddingTop: theme.spacing(5),
            paddingRight: theme.spacing(5),
            paddingBottom: theme.spacing(5),
            paddingLeft: theme.spacing(5),
        },
        button: {
            marginTop: theme.spacing(4),
        },
        row: {
            display: "flex",
            alignItems: "center",
        },
        nameColumn: {
            width: "20%",
        },
        inputColumn: {
            width: "70%",
        },
    });

export default outgoingWebhookConfigurationModalStyle;
